module.exports = __webpack_public_path__ + "static/media/svidpo.19683819.png";